import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

// Translations object
const translations = {
  pt: {
    // Common
    welcome: 'Bem-vindo',
    logout: 'Sair',
    login: 'Entrar',
    register: 'Criar Conta',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    download: 'Download',
    upload: 'Enviar',
    loading: 'A carregar...',
    error: 'Erro',
    success: 'Sucesso',
    admin: 'Admin',
    settings: 'Definições',
    back: 'Voltar',
    submit: 'Submeter',
    confirm: 'Confirmar',
    yes: 'Sim',
    no: 'Não',
    
    // Navigation
    home: 'Início',
    dashboard: 'Painel',
    documents: 'Documentos',
    notices: 'Avisos',
    
    // Landing Page
    landingTitle: 'Marketplace TVDE',
    landingSubtitle: 'A sua plataforma de gestão TVDE',
    learnMore: 'Saber Mais',
    contactUs: 'Contacte-nos',
    weeklyFee: 'Taxa Semanal',
    requirements: 'Requisitos',
    
    // Auth
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirmar Password',
    fullName: 'Nome Completo',
    phone: 'Telefone',
    language: 'Idioma',
    createAccount: 'Criar Conta de Motorista',
    alreadyHaveAccount: 'Já tem conta?',
    dontHaveAccount: 'Ainda não tem conta?',
    noAccount: 'Não tem conta?',
    loginTitle: 'Entrar na sua conta',
    registerTitle: 'Criar Conta',
    passwordMinLength: 'Mínimo 6 caracteres',
    passwordsDontMatch: 'As passwords não coincidem',
    invalidCredentials: 'Email ou password incorretos',
    registrationSuccess: 'Registo concluído!',
    
    // RGPD
    rgpdTitle: 'Proteção de Dados e Consentimento',
    rgpdText1: 'Ao prosseguir com a criação da conta e ao submeter os seus dados pessoais e documentos, o utilizador declara que o faz de forma livre, informada e voluntária, autorizando o seu tratamento pela Marketplace TVDE, exclusivamente para efeitos de gestão da conta, verificação de identidade e cumprimento de obrigações legais.',
    rgpdText2: 'Os dados serão tratados em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD) e demais legislação aplicável em Portugal, não sendo utilizados para fins distintos nem cedidos a terceiros, salvo obrigação legal.',
    rgpdText3: 'O utilizador pode, a qualquer momento, exercer os seus direitos de acesso, retificação, limitação ou eliminação dos dados, nos termos da lei.',
    rgpdCheckbox: 'Li e aceito a Política de Privacidade e o tratamento dos meus dados pessoais',
    rgpdRequired: 'Obrigatório: Deve aceitar os termos para criar a conta',
    rgpdMustAccept: 'Deve aceitar os Termos de Proteção de Dados para continuar',
    
    // Pending Approval
    pendingTitle: 'Aguarde a Aprovação da Sua Conta',
    pendingReceived: 'O seu registo foi recebido com sucesso!',
    pendingStep1Title: 'Registo Recebido',
    pendingStep1Desc: 'A sua candidatura está a ser analisada',
    pendingStep2Title: 'Análise em Curso',
    pendingStep2Desc: 'O administrador está a rever os seus dados',
    pendingStep3Title: 'Ativação da Conta',
    pendingStep3Desc: 'Receberá um email quando for aprovado',
    pendingEmailNotice: 'Fique Atento ao Seu Email',
    pendingEmailText: 'Assim que a sua conta for aprovada, receberá um email com instruções para fazer login.',
    pendingBackHome: 'Voltar à Página Inicial',
    pendingEstimatedTime: 'Tempo estimado de aprovação: 24-48 horas',
    pendingUrgentContact: 'Para questões urgentes, contacte:',
    
    // Dashboard
    dashboardWelcome: 'Bem-vindo',
    dashboardMessage: 'Espero que te encontres bem! Escolhe bem as tuas viagens, descansa e conduz com cuidado.',
    dashboardSubMessage: 'Aqui podes gerir as tuas tarefas, ver os teus ganhos e consultar documentos importantes.',
    
    // Tasks
    taskList: 'Lista de Tarefas',
    taskReciboVerde: 'Recibo verde corrente emitido?',
    taskSeguroPayment: 'Próximo pagamento seguro até:',
    taskInspeccao: 'Próxima inspeção até:',
    taskExtintor: 'Extintor, kit primeiros socorros e placas TVDE ok?',
    taskDocumentacao: 'Toda a documentação está consigo?',
    taskSegurancaSocial: 'Segurança social em dia?',
    taskIVA: 'IVA em dia?',
    taskPaid: 'Pago',
    taskDone: 'Feita',
    
    // Earnings
    weeklyEarnings: 'Ganhos Semanais',
    addEarning: 'Adicionar',
    noEarningsYet: 'Ainda não há ganhos registados',
    addFirstEarning: 'Adicionar Primeiro Ganho',
    addWeeklyEarning: 'Adicionar Ganho Semanal',
    week: 'Semana',
    value: 'Valor',
    
    // Documents
    sendDocuments: 'Enviar Documentos',
    vehicleRegistration: 'Registo de viatura',
    generalDocuments: 'Documentos Gerais',
    myDocuments: 'Meus Documentos',
    paymentReceipts: 'Comprovativos de Pagamento',
    noReceiptsAvailable: 'Nenhum comprovativo disponível',
    
    // Green Receipt
    sendGreenReceipt: 'Enviar Recibo Verde',
    greenReceiptSent: 'Recibo Enviado',
    greenReceiptMonth: 'Mês',
    greenReceiptAlreadySent: 'Já enviou este mês. Pode enviar novamente para substituir.',
    greenReceiptSuccess: 'Recibo Verde enviado com sucesso!',
    
    // Account
    deleteAccount: 'Eliminar Minha Conta',
    deleteAccountWarning: 'Esta ação é irreversível e eliminará todos os seus dados.',
    deleteAccountTitle: 'Eliminar Conta',
    deleteAccountAttention: 'Atenção! Esta ação é irreversível.',
    deleteAccountInfo: 'Ao eliminar a sua conta, todos os seus dados serão permanentemente removidos, incluindo:',
    deleteAccountData1: 'Documentos enviados',
    deleteAccountData2: 'Recibos verdes',
    deleteAccountData3: 'Histórico de ganhos',
    deleteAccountData4: 'Tarefas e configurações',
    deleteAccountConfirm: 'Para confirmar, escreva ELIMINAR abaixo:',
    deleteAccountSuccess: 'Conta eliminada com sucesso. Obrigado por ter estado connosco.',
    deleteAccountError: 'Erro ao eliminar conta. Por favor, tente novamente.',
    
    // Notices
    notices: 'Avisos',
    noNotices: 'Não há avisos no momento',
    
    // Dashboard Extra
    hello: 'Olá',
    taskDocumentacaoFull: 'Toda a documentação está consigo? (seguro, contratos, etc.)',
    earningsLabel: 'Ganhos (€)',
    valueEur: 'Valor (€)',
    exValue: 'Ex: 450.00',
    errorAddingEarning: 'Erro ao adicionar ganho',
    vehicleRegistrationFull: 'Registo de viatura e outros',
    receivedDocuments: 'Documentos Recebidos',
    managerFiles: 'Ficheiros do gestor',
    accountsAndReceipts: 'Contas e Comprovativo',
    downloadError: 'Erro ao fazer download',
    
    // Dashboard Driver (DashboardPage.js)
    d_hello: 'Olá',
    d_help: 'Ajuda',
    d_profile: 'Perfil',
    d_exit: 'Sair',
    d_management: 'Gestão',
    d_installApp: 'Instalar App Marketplace TVDE',
    d_installAppDesc: 'Acesso rápido no seu telemóvel',
    d_welcome: 'Bem-vindo',
    d_welcomeMsg: 'Espero que te encontres bem! Escolhe bem as tuas viagens, descansa e conduz com cuidado.',
    d_welcomeSub: 'Aqui podes gerir as tuas tarefas, ver os teus ganhos e consultar documentos importantes.',
    d_pendingReceipts: 'Recibos Verdes Pendentes',
    d_pendingReceiptsMsg: 'semana(s) a aguardar confirmação',
    d_week: 'Semana',
    d_valueToIssue: 'Valor a emitir',
    d_issuedReceipt: 'Já emitiu o Recibo Verde referente a esta semana?',
    d_yesIssued: 'SIM, emiti',
    d_notYet: 'NÃO, ainda não',
    d_clickToConfirm: 'Clique num botão para expandir e confirmar',
    d_issueReceiptPortal: 'Emitir Recibo no Portal das Finanças (AT.gov.pt)',
    d_sendDocuments: 'Enviar Documentos',
    d_vehicleRegOthers: 'Registo de viatura e outros',
    d_receivedDocuments: 'Documentos Recebidos',
    d_managerFiles: 'Ficheiros do gestor',
    d_taskList: 'Lista de Tarefas',
    d_greenReceipt: 'Recibo verde corrente emitido?',
    d_nextInsurance: 'Próximo pagamento seguro até:',
    d_nextInspection: 'Próxima inspeção até:',
    d_extinguisherKit: 'Extintor, kit primeiros socorros e placas TVDE ok?',
    d_allDocsWith: 'Toda a documentação está consigo? (seguro, contratos, etc.)',
    d_socialSecurity: 'Segurança social em dia?',
    d_vatUpToDate: 'IVA em dia?',
    d_weeklyEarnings: 'Ganhos Semanais',
    d_add: 'Adicionar',
    d_noEarnings: 'Ainda não há ganhos registados',
    d_addFirstEarning: 'Adicionar Primeiro Ganho',
    d_addWeeklyEarning: 'Adicionar Ganho Semanal',
    d_earnings: 'Ganhos (€)',
    d_value: 'Valor (€)',
    d_exValue: 'Ex: 450.00',
    d_accountsReceipts: 'Contas e Comprovativo',
    d_noReceipts: 'Nenhum comprovativo disponível',
    d_notices: 'Avisos',
    d_timeClock: 'Relógio de Ponto',
    d_startShift: 'Iniciar Turno',
    d_endShift: 'Terminar Turno',
    d_activeShift: 'Turno Ativo',
    d_shiftHistory: 'Histórico de Turnos',
    d_date: 'Data',
    d_start: 'Início',
    d_end: 'Fim',
    d_duration: 'Duração',
    d_noRecords: 'Sem registos',
    d_sosEmergency: 'Emergência SOS',
    d_sosDesc: 'Em caso de emergência, clique no botão SOS',
    d_fuelCard: 'Cartão Frota',
    d_fuelConsumption: 'Consumos de Combustível',
    d_noConsumption: 'Sem consumos registados',
    d_viewContract: 'Contrato',
    d_downloadContract: 'Download Contrato',
    d_weeklyAccounts: 'Contas Semanais',
    d_totalTransfer: 'Valor Total a Transferir',
    d_close: 'Fechar',
    d_viewDetails: 'Ver Detalhes',
    d_companyDocuments: 'Documentos da Empresa',
    d_noDocuments: 'Sem documentos',
    d_broadcast: 'Mensagem da Empresa',
    d_expiryAlerts: 'Alertas de Validade',
    d_expired: 'VENCIDO! Regularize imediatamente.',
    d_expiresIn: 'Expira em',
    d_days: 'dias',
    d_expiryDate: 'Data de vencimento',
    d_quickNotes: 'Notas Rápidas',
    d_reminders: 'Lembretes',
    d_today: 'Hoje',
    d_calendar: 'Calendário',
    d_notifications: 'Notificações',
    d_markAllRead: 'Marcar todas como lidas',
    d_noNotifications: 'Sem notificações',
    d_uboltPrints: 'Prints Pagamento',
    d_uploadPrint: 'Enviar Print',
    d_platform: 'Plataforma',
    d_selectFile: 'Selecionar Ficheiro',
    d_send: 'Enviar',
    d_myPrints: 'Meus Prints',
    d_noPrints: 'Nenhum print enviado',
    d_tutorial: 'Tutorial',
    d_next: 'Seguinte',
    d_previous: 'Anterior',
    d_finish: 'Terminar',
    d_skip: 'Saltar',
    d_editProfile: 'Editar Perfil',
    d_name: 'Nome',
    d_email: 'Email',
    d_phone: 'Telefone',
    d_nif: 'NIF',
    d_iban: 'IBAN',
    d_address: 'Morada',
    d_saveChanges: 'Guardar Alterações',
    d_deleteAccount: 'Eliminar Conta',
    d_confirmDelete: 'Para confirmar, escreva ELIMINAR:',
    d_errorLoadingData: 'Erro ao carregar dados',
    
    // SOS
    sos_title: 'Sistema de Emergência',
    sos_button: 'SOS',
    sos_panic: 'PÂNICO',
    sos_active: 'SOS Ativo',
    sos_panicActive: 'MODO PÂNICO ATIVO',
    sos_location: 'Localização',
    sos_timeRemaining: 'Tempo Restante',
    sos_cancel: 'Cancelar SOS',
    sos_upgradePanic: 'Ativar PÂNICO',
    sos_connected: 'Conectado',
    sos_disconnected: 'Desconectado',
    sos_consent_title: 'Consentimento de Localização',
    sos_consent_text: 'Para usar o SOS, precisamos de aceder à sua localização em tempo real durante emergências.',
    sos_consent_privacy: 'Li e aceito a política de privacidade',
    sos_consent_accept: 'Aceitar e Continuar',
    sos_confirm_title: 'Ativar SOS?',
    sos_confirm_text: 'Ao ativar, a sua localização será partilhada com o gestor da frota durante 40 minutos.',
    sos_confirm_activate: 'Ativar SOS',
    sos_panic_confirm_title: 'ATIVAR MODO PÂNICO?',
    sos_panic_confirm_text: 'O modo pânico alerta imediatamente o gestor e mantém a localização em tempo real. Use apenas em situações de perigo real.',
    sos_panic_activate: 'ATIVAR PÂNICO',
    sos_police_title: 'Esquadra Mais Próxima',
    sos_police_address: 'Morada',
    sos_police_phone: 'Telefone',
    sos_police_directions: 'Obter Direções',
    sos_otherAlerts: 'Outros Alertas Ativos',
    sos_noActiveAlerts: 'Sem alertas ativos',
    sos_reportPolice: 'Reportar Paragem Policial',
    sos_reportAccident: 'Reportar Acidente',
    sos_errorLocation: 'Erro ao obter localização. Verifique as permissões.',
    sos_errorActivate: 'Erro ao ativar SOS',
    sos_errorCancel: 'Erro ao cancelar SOS',
    
    // Install App
    install_title: 'Instalar Aplicação',
    install_description: 'Instale a aplicação no seu dispositivo para acesso rápido',
    install_button: 'Instalar App',
    install_ios: 'No iPhone: toque em Partilhar e depois em "Adicionar ao Ecrã Principal"',
    install_android: 'No Android: toque nos 3 pontos e depois em "Adicionar ao Ecrã Principal"',
  },
  en: {
    // Common
    welcome: 'Welcome',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    download: 'Download',
    upload: 'Upload',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    admin: 'Admin',
    settings: 'Settings',
    back: 'Back',
    submit: 'Submit',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    
    // Navigation
    home: 'Home',
    dashboard: 'Dashboard',
    documents: 'Documents',
    notices: 'Notices',
    
    // Landing Page
    landingTitle: 'Marketplace TVDE',
    landingSubtitle: 'Your TVDE management platform',
    learnMore: 'Learn More',
    contactUs: 'Contact Us',
    weeklyFee: 'Weekly Fee',
    requirements: 'Requirements',
    
    // Auth
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    phone: 'Phone',
    language: 'Language',
    createAccount: 'Create Driver Account',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    loginTitle: 'Sign In',
    registerTitle: 'Create Account',
    passwordMinLength: 'Minimum 6 characters',
    passwordsDontMatch: 'Passwords do not match',
    invalidCredentials: 'Incorrect email or password',
    registrationSuccess: 'Registration complete!',
    
    // RGPD
    rgpdTitle: 'Data Protection and Consent',
    rgpdText1: 'By proceeding with account creation and submitting your personal data and documents, you declare that you do so freely, informedly and voluntarily, authorizing their processing by Marketplace TVDE, exclusively for account management, identity verification and compliance with legal obligations.',
    rgpdText2: 'Data will be processed in accordance with the General Data Protection Regulation (GDPR) and other applicable legislation in Portugal, and will not be used for other purposes or transferred to third parties, except where legally required.',
    rgpdText3: 'You may, at any time, exercise your rights of access, rectification, restriction or deletion of data, in accordance with the law.',
    rgpdCheckbox: 'I have read and accept the Privacy Policy and the processing of my personal data',
    rgpdRequired: 'Required: You must accept the terms to create an account',
    rgpdMustAccept: 'You must accept the Data Protection Terms to continue',
    
    // Pending Approval
    pendingTitle: 'Awaiting Account Approval',
    pendingReceived: 'Your registration was received successfully!',
    pendingStep1Title: 'Registration Received',
    pendingStep1Desc: 'Your application is being reviewed',
    pendingStep2Title: 'Under Review',
    pendingStep2Desc: 'The administrator is reviewing your data',
    pendingStep3Title: 'Account Activation',
    pendingStep3Desc: 'You will receive an email when approved',
    pendingEmailNotice: 'Check Your Email',
    pendingEmailText: 'Once your account is approved, you will receive an email with login instructions.',
    pendingBackHome: 'Back to Home',
    pendingEstimatedTime: 'Estimated approval time: 24-48 hours',
    pendingUrgentContact: 'For urgent matters, contact:',
    
    // Dashboard
    dashboardWelcome: 'Welcome',
    dashboardMessage: 'Hope you are doing well! Choose your trips wisely, rest and drive safely.',
    dashboardSubMessage: 'Here you can manage your tasks, view your earnings and check important documents.',
    
    // Tasks
    taskList: 'Task List',
    taskReciboVerde: 'Current green receipt issued?',
    taskSeguroPayment: 'Next insurance payment due:',
    taskInspeccao: 'Next inspection due:',
    taskExtintor: 'Fire extinguisher, first aid kit and TVDE plates OK?',
    taskDocumentacao: 'All documentation with you?',
    taskSegurancaSocial: 'Social security up to date?',
    taskIVA: 'VAT up to date?',
    taskPaid: 'Paid',
    taskDone: 'Done',
    
    // Earnings
    weeklyEarnings: 'Weekly Earnings',
    addEarning: 'Add',
    noEarningsYet: 'No earnings recorded yet',
    addFirstEarning: 'Add First Earning',
    addWeeklyEarning: 'Add Weekly Earning',
    week: 'Week',
    value: 'Value',
    
    // Documents
    sendDocuments: 'Send Documents',
    vehicleRegistration: 'Vehicle registration',
    generalDocuments: 'General Documents',
    myDocuments: 'My Documents',
    paymentReceipts: 'Payment Receipts',
    noReceiptsAvailable: 'No receipts available',
    
    // Green Receipt
    sendGreenReceipt: 'Send Green Receipt',
    greenReceiptSent: 'Receipt Sent',
    greenReceiptMonth: 'Month',
    greenReceiptAlreadySent: 'Already sent this month. You can send again to replace.',
    greenReceiptSuccess: 'Green receipt sent successfully!',
    
    // Account
    deleteAccount: 'Delete My Account',
    deleteAccountWarning: 'This action is irreversible and will delete all your data.',
    deleteAccountTitle: 'Delete Account',
    deleteAccountAttention: 'Warning! This action is irreversible.',
    deleteAccountInfo: 'By deleting your account, all your data will be permanently removed, including:',
    deleteAccountData1: 'Uploaded documents',
    deleteAccountData2: 'Green receipts',
    deleteAccountData3: 'Earnings history',
    deleteAccountData4: 'Tasks and settings',
    deleteAccountConfirm: 'To confirm, type DELETE below:',
    deleteAccountSuccess: 'Account deleted successfully. Thank you for being with us.',
    deleteAccountError: 'Error deleting account. Please try again.',
    
    // Notices
    notices: 'Notices',
    noNotices: 'No notices at the moment',
    
    // Dashboard Extra
    hello: 'Hello',
    taskDocumentacaoFull: 'All documentation with you? (insurance, contracts, etc.)',
    earningsLabel: 'Earnings (€)',
    valueEur: 'Value (€)',
    exValue: 'E.g.: 450.00',
    errorAddingEarning: 'Error adding earning',
    vehicleRegistrationFull: 'Vehicle registration and others',
    receivedDocuments: 'Received Documents',
    managerFiles: 'Files from manager',
    accountsAndReceipts: 'Accounts & Receipts',
    downloadError: 'Error downloading file',
    
    // Dashboard Driver (DashboardPage.js)
    d_hello: 'Hello',
    d_help: 'Help',
    d_profile: 'Profile',
    d_exit: 'Logout',
    d_management: 'Management',
    d_installApp: 'Install Marketplace TVDE App',
    d_installAppDesc: 'Quick access on your phone',
    d_welcome: 'Welcome',
    d_welcomeMsg: 'Hope you are doing well! Choose your trips wisely, rest and drive safely.',
    d_welcomeSub: 'Here you can manage your tasks, view your earnings and check important documents.',
    d_pendingReceipts: 'Pending Green Receipts',
    d_pendingReceiptsMsg: 'week(s) awaiting confirmation',
    d_week: 'Week',
    d_valueToIssue: 'Value to issue',
    d_issuedReceipt: 'Have you issued the Green Receipt for this week?',
    d_yesIssued: 'YES, I issued it',
    d_notYet: 'NO, not yet',
    d_clickToConfirm: 'Click a button to expand and confirm',
    d_issueReceiptPortal: 'Issue Receipt on Finance Portal (AT.gov.pt)',
    d_sendDocuments: 'Send Documents',
    d_vehicleRegOthers: 'Vehicle registration and others',
    d_receivedDocuments: 'Received Documents',
    d_managerFiles: 'Files from manager',
    d_taskList: 'Task List',
    d_greenReceipt: 'Current green receipt issued?',
    d_nextInsurance: 'Next insurance payment due:',
    d_nextInspection: 'Next inspection due:',
    d_extinguisherKit: 'Fire extinguisher, first aid kit and TVDE plates OK?',
    d_allDocsWith: 'All documentation with you? (insurance, contracts, etc.)',
    d_socialSecurity: 'Social security up to date?',
    d_vatUpToDate: 'VAT up to date?',
    d_weeklyEarnings: 'Weekly Earnings',
    d_add: 'Add',
    d_noEarnings: 'No earnings recorded yet',
    d_addFirstEarning: 'Add First Earning',
    d_addWeeklyEarning: 'Add Weekly Earning',
    d_earnings: 'Earnings (€)',
    d_value: 'Value (€)',
    d_exValue: 'E.g.: 450.00',
    d_accountsReceipts: 'Accounts & Receipts',
    d_noReceipts: 'No receipts available',
    d_notices: 'Notices',
    d_timeClock: 'Time Clock',
    d_startShift: 'Start Shift',
    d_endShift: 'End Shift',
    d_activeShift: 'Active Shift',
    d_shiftHistory: 'Shift History',
    d_date: 'Date',
    d_start: 'Start',
    d_end: 'End',
    d_duration: 'Duration',
    d_noRecords: 'No records',
    d_sosEmergency: 'SOS Emergency',
    d_sosDesc: 'In case of emergency, click the SOS button',
    d_fuelCard: 'Fleet Card',
    d_fuelConsumption: 'Fuel Consumption',
    d_noConsumption: 'No consumption recorded',
    d_viewContract: 'Contract',
    d_downloadContract: 'Download Contract',
    d_weeklyAccounts: 'Weekly Accounts',
    d_totalTransfer: 'Total Transfer Amount',
    d_close: 'Close',
    d_viewDetails: 'View Details',
    d_companyDocuments: 'Company Documents',
    d_noDocuments: 'No documents',
    d_broadcast: 'Company Message',
    d_expiryAlerts: 'Expiry Alerts',
    d_expired: 'EXPIRED! Resolve immediately.',
    d_expiresIn: 'Expires in',
    d_days: 'days',
    d_expiryDate: 'Expiry date',
    d_quickNotes: 'Quick Notes',
    d_reminders: 'Reminders',
    d_today: 'Today',
    d_calendar: 'Calendar',
    d_notifications: 'Notifications',
    d_markAllRead: 'Mark all as read',
    d_noNotifications: 'No notifications',
    d_uboltPrints: 'Payment Prints',
    d_uploadPrint: 'Upload Print',
    d_platform: 'Platform',
    d_selectFile: 'Select File',
    d_send: 'Send',
    d_myPrints: 'My Prints',
    d_noPrints: 'No prints uploaded',
    d_tutorial: 'Tutorial',
    d_next: 'Next',
    d_previous: 'Previous',
    d_finish: 'Finish',
    d_skip: 'Skip',
    d_editProfile: 'Edit Profile',
    d_name: 'Name',
    d_email: 'Email',
    d_phone: 'Phone',
    d_nif: 'Tax ID',
    d_iban: 'IBAN',
    d_address: 'Address',
    d_saveChanges: 'Save Changes',
    d_deleteAccount: 'Delete Account',
    d_confirmDelete: 'To confirm, type DELETE:',
    d_errorLoadingData: 'Error loading data',
    
    // SOS
    sos_title: 'Emergency System',
    sos_button: 'SOS',
    sos_panic: 'PANIC',
    sos_active: 'SOS Active',
    sos_panicActive: 'PANIC MODE ACTIVE',
    sos_location: 'Location',
    sos_timeRemaining: 'Time Remaining',
    sos_cancel: 'Cancel SOS',
    sos_upgradePanic: 'Activate PANIC',
    sos_connected: 'Connected',
    sos_disconnected: 'Disconnected',
    sos_consent_title: 'Location Consent',
    sos_consent_text: 'To use SOS, we need to access your real-time location during emergencies.',
    sos_consent_privacy: 'I have read and accept the privacy policy',
    sos_consent_accept: 'Accept and Continue',
    sos_confirm_title: 'Activate SOS?',
    sos_confirm_text: 'When activated, your location will be shared with the fleet manager for 40 minutes.',
    sos_confirm_activate: 'Activate SOS',
    sos_panic_confirm_title: 'ACTIVATE PANIC MODE?',
    sos_panic_confirm_text: 'Panic mode immediately alerts the manager and maintains real-time location. Use only in situations of real danger.',
    sos_panic_activate: 'ACTIVATE PANIC',
    sos_police_title: 'Nearest Police Station',
    sos_police_address: 'Address',
    sos_police_phone: 'Phone',
    sos_police_directions: 'Get Directions',
    sos_otherAlerts: 'Other Active Alerts',
    sos_noActiveAlerts: 'No active alerts',
    sos_reportPolice: 'Report Police Stop',
    sos_reportAccident: 'Report Accident',
    sos_errorLocation: 'Error getting location. Check your permissions.',
    sos_errorActivate: 'Error activating SOS',
    sos_errorCancel: 'Error cancelling SOS',
    
    // Install App
    install_title: 'Install Application',
    install_description: 'Install the app on your device for quick access',
    install_button: 'Install App',
    install_ios: 'On iPhone: tap Share and then "Add to Home Screen"',
    install_android: 'On Android: tap the 3 dots and then "Add to Home Screen"',
  },
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Try to get from localStorage first
    const saved = localStorage.getItem('language');
    return saved || 'pt';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Translation function
  const t = (key) => {
    return translations[language]?.[key] || translations['pt'][key] || key;
  };

  // Get all translations for current language
  const getTranslations = () => translations[language] || translations['pt'];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getTranslations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
